import { BaseQuantity } from "../../interface/functionalityInterface";
// Base quantity

export const Temperature: BaseQuantity = {
  id: "001temperature",
  name: "temperature",
  type: "numeric",
  value: "",
  symbol: "T",
  baseUnit: "°K",
  selectedUnit: "°C",
  units: [
    { name: "°K", fromConst: 1, toConst: 1 },
    {
      name: "°F",
      fromConst: "((value) - 32) * 5/9 + 273.15",
      toConst: "((value) - 273.15) * 9/5 + 32",
    },
    {
      name: "°C",
      fromConst: "(value) + 273.15",
      toConst: "(value) - 273.15",
    },
  ],
};
